(function () {
  function parseJSON(node, fallback) {
    if (!node) return fallback;

    try {
      return JSON.parse(node.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeReference(value) {
    return String(value || '')
      .trim()
      .replace(/^#/, '')
      .replace(/\s+/g, '')
      .toLowerCase();
  }

  function normalizeOrders(orders) {
    if (!Array.isArray(orders)) return [];

    return orders
      .filter(function (order) {
        return order && (order.id || order.name || order.orderNumber);
      })
      .map(function (order, index) {
        var id = String(order.id || order.name || order.orderNumber || index);
        var items = Array.isArray(order.items) ? order.items : [];

        return {
          id: id,
          name: order.name || (order.orderNumber ? '#' + order.orderNumber : id),
          orderNumber: order.orderNumber || order.number || '',
          processedAt: order.processedAt || order.date || '',
          processedAtRaw: order.processedAtRaw || '',
          total: order.total || order.totalPrice || '',
          financialStatus: order.financialStatus || '',
          fulfillmentStatus: order.fulfillmentStatus || order.status || '',
          email: order.email || '',
          withdrawalEligible: order.withdrawalEligible,
          withdrawalMessage: order.withdrawalMessage || order.ineligibilityReason || '',
          items: items.map(function (item, itemIndex) {
            var itemId = String(item.id || item.lineItemId || item.sku || itemIndex);
            var qty = parseInt(item.returnableQuantity || item.quantity || 1, 10);

            if (!qty || qty < 1) qty = 1;

            return {
              id: itemId,
              lineItemId: item.lineItemId || item.id || itemId,
              title: item.title || 'Order item',
              variantTitle: item.variantTitle || item.variant || '',
              sku: item.sku || '',
              quantity: parseInt(item.quantity || qty, 10) || qty,
              returnableQuantity: qty,
              image: item.image || null
            };
          })
        };
      });
  }

  function findByDataItem(root, selector, itemId) {
    var nodes = root.querySelectorAll(selector);
    var id = String(itemId);

    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].getAttribute('data-item-id') === id) return nodes[i];
    }

    return null;
  }

  function withTimeout(ms) {
    if (!window.AbortController) {
      return { signal: undefined, clear: function () {} };
    }

    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, ms);

    return {
      signal: controller.signal,
      clear: function () {
        window.clearTimeout(timer);
      }
    };
  }

  function setHidden(node, shouldHide) {
    if (!node) return;
    node.hidden = shouldHide;
  }

  function initWithdrawalForm(root) {
    if (!root || root.dataset.cpWithdrawalBound === 'true') return;
    root.dataset.cpWithdrawalBound = 'true';

    var lookupForm = root.querySelector('[data-cp-withdrawal-lookup-form]');
    var requestForm = root.querySelector('[data-cp-withdrawal-request-form]');
    var submitForm = root.querySelector('[data-cp-withdrawal-submit-form]');
    var orderInput = root.querySelector('[data-cp-order-reference]');
    var emailInput = root.querySelector('[data-cp-order-email]');
    var messageNode = root.querySelector('[data-cp-withdrawal-message]');
    var ordersNode = root.querySelector('[data-cp-withdrawal-orders]');
    var itemsNode = root.querySelector('[data-cp-withdrawal-items]');
    var useAccountButton = root.querySelector('[data-cp-use-account-orders]');
    var backToLookupButton = root.querySelector('[data-cp-back-to-lookup]');
    var backToRequestButton = root.querySelector('[data-cp-back-to-request]');
    var startAgainButton = root.querySelector('[data-cp-start-again]');
    var lookupButton = root.querySelector('[data-cp-lookup-button]');
    var lookupButtonText = root.querySelector('[data-cp-lookup-button-text]');
    var nextStepButton = root.querySelector('[data-cp-next-step-button]');
    var nextStepButtonText = root.querySelector('[data-cp-next-step-button-text]');
    var submitButton = root.querySelector('[data-cp-submit-button]');
    var submitButtonText = root.querySelector('[data-cp-submit-button-text]');
    var contactFallbackForm = root.querySelector('.cp-withdrawal__contact-fallback');
    var reviewSummary = root.querySelector('[data-cp-review-summary]');
    var successPanel = root.querySelector('[data-cp-success-panel]');
    var successCopy = root.querySelector('[data-cp-success-copy]');
    var successReference = root.querySelector('[data-cp-success-reference]');
    var reasonInput = root.querySelector('[data-cp-withdrawal-reason]');
    var noteInput = root.querySelector('[data-cp-withdrawal-note]');
    var confirmInput = root.querySelector('[data-cp-withdrawal-confirm]');
    var paymentOptionInput = root.querySelector('[data-cp-payment-option]');
    var panels = root.querySelectorAll('[data-cp-step-panel]');
    var indicators = root.querySelectorAll('[data-cp-step-indicator]');
    var payload = parseJSON(root.querySelector('[data-cp-withdrawal-customer-orders]'), {
      customer: {},
      orders: []
    });
    var accountOrders = normalizeOrders(payload.orders);
    var activeOrders = [];
    var selectedOrder = null;
    var lookupEndpoint = root.dataset.lookupEndpoint || '';
    var submitEndpoint = root.dataset.submitEndpoint || '';
    var supportEmail = root.dataset.supportEmail || '';
    var returnShippingFeeDisplay = root.dataset.returnShippingFeeDisplay || '$12';
    var returnShippingFeeCurrency = root.dataset.returnShippingFeeCurrency || 'USD';
    var returnShippingFeeVariantId = root.dataset.returnShippingFeeVariantId || '';
    var returnShippingFeeProductUrl = '/products/return-shipping-fee';
    var requestTimeout = parseInt(root.dataset.requestTimeout || '15000', 10);
    var withdrawalWindowDays = parseInt(root.dataset.withdrawalWindowDays || '14', 10);
    if (!withdrawalWindowDays || withdrawalWindowDays < 1) withdrawalWindowDays = 14;

    function setStep(step) {
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-cp-step-panel') !== String(step);
      });

      indicators.forEach(function (indicator) {
        var isActive = indicator.getAttribute('data-cp-step-indicator') === String(step);
        indicator.classList.toggle('is-active', isActive);
        if (isActive) {
          indicator.setAttribute('aria-current', 'step');
        } else {
          indicator.removeAttribute('aria-current');
        }
      });
    }

    function showMessage(type, text) {
      if (!messageNode) return;
      messageNode.className = 'cp-withdrawal__message is-' + type;
      messageNode.textContent = text;
      messageNode.hidden = false;
    }

    function clearMessage() {
      if (!messageNode) return;
      messageNode.textContent = '';
      messageNode.hidden = true;
      messageNode.className = 'cp-withdrawal__message';
    }

    function setLookupBusy(isBusy) {
      if (lookupButton) lookupButton.disabled = isBusy;
      if (lookupButtonText) lookupButtonText.textContent = isBusy ? 'Finding...' : 'Find order';
    }

    function setSubmitBusy(isBusy) {
      if (submitButton) submitButton.disabled = isBusy;
      if (submitButtonText) submitButtonText.textContent = isBusy ? 'Preparing checkout...' : 'Continue to payment';
    }

    function setNextStepBusy(isBusy) {
      if (nextStepButton) nextStepButton.disabled = isBusy;
      if (nextStepButtonText) nextStepButtonText.textContent = isBusy ? 'Checking...' : 'Next step';
    }

    function getDateOnly(value) {
      var raw = String(value || '').trim();
      var match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
      var parsed;

      if (match) {
        parsed = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
      } else if (raw) {
        parsed = new Date(raw);
      }

      if (!parsed || Number.isNaN(parsed.getTime())) return null;
      return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    }

    function getOrderAgeDays(order) {
      var orderDate = getDateOnly(order.processedAtRaw || order.processedAt);
      if (!orderDate) return null;

      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return Math.floor((today.getTime() - orderDate.getTime()) / 86400000);
    }

    function getWindowExpiredMessage() {
      return "Can't withdraw because the " + withdrawalWindowDays + '-day withdrawal period is over.';
    }

    function getWithdrawalEligibility(order) {
      if (!order) {
        return { eligible: true, message: '' };
      }

      if (order.withdrawalEligible === false) {
        return {
          eligible: false,
          message: order.withdrawalMessage || getWindowExpiredMessage()
        };
      }

      var ageDays = getOrderAgeDays(order);
      if (ageDays !== null && ageDays > withdrawalWindowDays) {
        return {
          eligible: false,
          message: getWindowExpiredMessage()
        };
      }

      return { eligible: true, message: '' };
    }

    function findLocalOrders(orderReference, email) {
      var ref = normalizeReference(orderReference);
      var normalizedEmail = String(email || '').trim().toLowerCase();

      return accountOrders.filter(function (order) {
        var refs = [order.id, order.name, order.orderNumber].map(normalizeReference);
        var emailMatches = !normalizedEmail || !order.email || String(order.email).toLowerCase() === normalizedEmail;
        return emailMatches && refs.indexOf(ref) !== -1;
      });
    }

    function getOrderSubtitle(order) {
      var parts = [];
      if (order.processedAt) parts.push(order.processedAt);
      if (order.total) parts.push(order.total);
      if (order.financialStatus) parts.push(order.financialStatus);
      return parts.join(' / ');
    }

    function renderOrders(orders) {
      activeOrders = normalizeOrders(orders);
      selectedOrder = null;
      setHidden(requestForm, true);

      if (!ordersNode) return;

      if (!activeOrders.length) {
        ordersNode.innerHTML = '<div class="cp-withdrawal__message is-info">No matching orders were found.</div>';
        return;
      }

      ordersNode.innerHTML = activeOrders
        .map(function (order) {
          var eligibility = getWithdrawalEligibility(order);
          var status = eligibility.eligible ? order.fulfillmentStatus || 'Order' : withdrawalWindowDays + ' days over';
          var classes = 'cp-withdrawal-order' + (eligibility.eligible ? '' : ' is-disabled');
          var disabledAttr = eligibility.eligible ? '' : ' disabled aria-disabled="true"';
          var warning = eligibility.eligible
            ? ''
            : '<span class="cp-withdrawal-order__warning">' + escapeHTML(eligibility.message) + '</span>';

          return [
            '<button class="' + classes + '" type="button" data-cp-order-id="' + escapeHTML(order.id) + '"' + disabledAttr + '>',
            '<span class="cp-withdrawal-order__radio" aria-hidden="true"></span>',
            '<span>',
            '<span class="cp-withdrawal-order__title">' + escapeHTML(order.name) + '</span>',
            '<span class="cp-withdrawal-order__meta">' + escapeHTML(getOrderSubtitle(order)) + '</span>',
            warning,
            '</span>',
            '<span class="cp-withdrawal-order__status">' + escapeHTML(status) + '</span>',
            '</button>'
          ].join('');
        })
        .join('');

      setStep(2);
    }

    function renderItems(order) {
      if (!itemsNode) return;

      if (!order.items.length) {
        itemsNode.innerHTML = '<div class="cp-withdrawal__message is-info">This order was found, but no product line items were available to show. Customer support can still verify the order after submission.</div>';
        return;
      }

      itemsNode.innerHTML = order.items
        .map(function (item) {
          var max = item.returnableQuantity || item.quantity || 1;
          var meta = [];
          if (item.variantTitle && item.variantTitle !== 'Default Title') meta.push(item.variantTitle);
          if (item.sku) meta.push('SKU ' + item.sku);

          return [
            '<label class="cp-withdrawal-item">',
            '<input type="checkbox" data-cp-item-select data-item-id="' + escapeHTML(item.id) + '">',
            item.image
              ? '<span class="cp-withdrawal-item__image"><img src="' + escapeHTML(item.image) + '" alt=""></span>'
              : '<span class="cp-withdrawal-item__placeholder" aria-hidden="true">CP</span>',
            '<span>',
            '<span class="cp-withdrawal-item__title">' + escapeHTML(item.title) + '</span>',
            '<span class="cp-withdrawal-item__meta">' + escapeHTML(meta.join(' / ')) + '</span>',
            '</span>',
            '<span class="cp-withdrawal-item__qty">',
            '<span>Qty</span>',
            '<input type="number" min="1" max="' + escapeHTML(max) + '" value="' + escapeHTML(max) + '" data-cp-item-qty data-item-id="' + escapeHTML(item.id) + '">',
            '</span>',
            '</label>'
          ].join('');
        })
        .join('');
    }

    function selectOrder(orderId) {
      selectedOrder = activeOrders.find(function (order) {
        return String(order.id) === String(orderId);
      });

      if (selectedOrder && !getWithdrawalEligibility(selectedOrder).eligible) {
        setHidden(requestForm, true);
        return;
      }

      root.querySelectorAll('.cp-withdrawal-order').forEach(function (button) {
        button.classList.toggle('is-selected', button.getAttribute('data-cp-order-id') === String(orderId));
      });

      if (selectedOrder) {
        renderItems(selectedOrder);
        setHidden(requestForm, false);
      }
    }

    function fetchOrders(orderReference, email) {
      if (!lookupEndpoint) {
        return Promise.resolve([]);
      }

      var timeout = withTimeout(requestTimeout);

      return fetch(lookupEndpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        signal: timeout.signal,
        body: JSON.stringify({
          orderReference: orderReference,
          email: email,
          source: 'crep-protect-withdrawal-form'
        })
      })
        .then(function (response) {
          timeout.clear();
          if (!response.ok) {
            throw new Error('Lookup failed');
          }
          return response.json();
        })
        .then(function (data) {
          if (Array.isArray(data.orders)) return data.orders;
          if (data.order) return [data.order];
          return [];
        })
        .catch(function (error) {
          timeout.clear();
          throw error;
        });
    }

    function showLookupUnavailable() {
      var supportSuffix = supportEmail ? ' or contact ' + supportEmail + '.' : '.';

      showMessage('error', 'We could not fetch that order. Check your order ID and checkout email, then try again' + supportSuffix);
    }

    function getSelectedItems() {
      if (!selectedOrder) return [];

      if (!selectedOrder.items.length) return [];

      return selectedOrder.items
        .filter(function (item) {
          var checkbox = findByDataItem(root, '[data-cp-item-select]', item.id);
          return checkbox && checkbox.checked;
        })
        .map(function (item) {
          var qtyInput = findByDataItem(root, '[data-cp-item-qty]', item.id);
          var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
          var max = item.returnableQuantity || item.quantity || 1;

          if (!qty || qty < 1) qty = 1;
          if (qty > max) qty = max;

          return {
            id: item.id,
            lineItemId: item.lineItemId,
            title: item.title,
            variantTitle: item.variantTitle,
            sku: item.sku,
            quantity: qty
          };
        });
    }

    function validateSelectedRequest() {
      if (!selectedOrder) {
        showMessage('error', 'Select the order you want to withdraw or return.');
        return false;
      }

      var orderEligibility = getWithdrawalEligibility(selectedOrder);
      if (!orderEligibility.eligible) {
        showMessage('error', orderEligibility.message);
        return false;
      }

      if (selectedOrder.items.length && !getSelectedItems().length) {
        showMessage('error', 'Select at least one item from the order.');
        return false;
      }

      return true;
    }

    function validatePaymentOption() {
      if (paymentOptionInput && !paymentOptionInput.checked) {
        showMessage('error', 'Confirm the return shipping payment option.');
        paymentOptionInput.focus();
        return false;
      }

      return true;
    }

    function getReturnShippingFee() {
      return {
        required: true,
        amount: returnShippingFeeDisplay,
        currency: returnShippingFeeCurrency,
        variantId: returnShippingFeeVariantId
      };
    }

    function renderReviewSummary() {
      if (!reviewSummary || !selectedOrder) return;

      var items = getSelectedItems();
      var productSummary = items.length
        ? items.map(function (item) {
            var name = item.title || 'Selected product';
            if (item.variantTitle && item.variantTitle !== 'Default Title') {
              name += ' / ' + item.variantTitle;
            }

            return '<span>' + escapeHTML(name) + '<em>Qty ' + escapeHTML(item.quantity || 1) + '</em></span>';
          }).join('')
        : '<span>Selected products will show here</span>';

      reviewSummary.innerHTML = [
        '<div class="cp-withdrawal-review__row"><span>Order</span><strong>' + escapeHTML(selectedOrder.name) + '</strong></div>',
        '<div class="cp-withdrawal-review__row"><span>Products selected</span><strong class="cp-withdrawal-review__products">' + productSummary + '</strong></div>',
        '<div class="cp-withdrawal-review__row"><span>Return shipping charge</span><strong>' + escapeHTML(returnShippingFeeDisplay) + '</strong></div>'
      ].join('');
    }

    function buildRequestPayload() {
      var selectedItems = getSelectedItems();
      var selectedReason = reasonInput && reasonInput.selectedOptions.length ? reasonInput.selectedOptions[0] : null;
      var email = (emailInput ? emailInput.value.trim() : '') || selectedOrder.email || '';

      return {
        source: 'crep-protect-theme-withdrawal-form',
        order: {
          id: selectedOrder.id,
          name: selectedOrder.name,
          orderNumber: selectedOrder.orderNumber,
          email: email
        },
        customer: payload.customer || {},
        items: selectedItems,
        reason: reasonInput ? reasonInput.value : '',
        reasonLabel: selectedReason ? selectedReason.textContent : '',
        note: noteInput ? noteInput.value.trim() : '',
        returnShippingFee: getReturnShippingFee(),
        payment: {
          required: true,
          option: paymentOptionInput ? paymentOptionInput.value : 'return_shipping_fee',
          status: 'pending',
          nextStep: true
        },
        workflow: {
          target: 'shopify_order',
          requestedAction: 'refund_request',
          dashboardStatus: 'return_shipping_payment_pending',
          customerEmailEvent: 'return_initiated'
        },
        lookupFallback: false,
        requestedAt: new Date().toISOString(),
        requestedAction: 'refund_or_return_with_return_shipping_fee'
      };
    }

    function getNumericVariantId(value) {
      var raw = String(value || '').trim();
      var gidMatch = raw.match(/ProductVariant\/(\d+)/);

      if (gidMatch) return gidMatch[1];

      var numeric = raw.replace(/\D/g, '');
      return numeric || '';
    }

    function getCheckoutItemSummary(items) {
      if (!Array.isArray(items) || !items.length) return '';

      return items
        .map(function (item) {
          return (item.title || 'Selected product') + ' x ' + (item.quantity || 1);
        })
        .join(', ');
    }

    function buildReturnShippingCheckoutUrl() {
      return '/checkout';
    }

    function fetchJsonWithTimeout(url, options, timeoutMs) {
      var timeout = withTimeout(timeoutMs || 8000);

      options = options || {};
      options.signal = timeout.signal;

      return fetch(url, options).then(
        function (response) {
          timeout.clear();
          if (!response.ok) {
            throw new Error('Request failed');
          }
          return response.json();
        },
        function (error) {
          timeout.clear();
          throw error;
        }
      );
    }

    function getReturnShippingVariantId(product) {
      var variants = product && Array.isArray(product.variants) ? product.variants : [];
      var firstVariant = null;

      for (var i = 0; i < variants.length; i += 1) {
        if (!variants[i] || !variants[i].id) continue;
        if (!firstVariant) firstVariant = variants[i];
        if (variants[i].available !== false) return String(variants[i].id);
      }

      return firstVariant && firstVariant.id ? String(firstVariant.id) : '';
    }

    function cartHasVariant(cart, variantId) {
      var items = cart && Array.isArray(cart.items) ? cart.items : [];
      var id = String(variantId || '');

      for (var i = 0; i < items.length; i += 1) {
        if (String(items[i].variant_id || '') === id) return true;
      }

      return false;
    }

    function addReturnShippingProductToCart() {
      return fetchJsonWithTimeout(returnShippingFeeProductUrl + '.js', {
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin'
      })
        .then(function (product) {
          var variantId = getReturnShippingVariantId(product);

          if (!variantId) {
            throw new Error('Return shipping product has no variant');
          }

          return fetchJsonWithTimeout('/cart.js', {
            headers: {
              Accept: 'application/json'
            },
            credentials: 'same-origin'
          }).then(function (cart) {
            if (cartHasVariant(cart, variantId)) return cart;

            return fetchJsonWithTimeout('/cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              credentials: 'same-origin',
              body: JSON.stringify({
                id: variantId,
                quantity: 1
              })
            });
          });
        });
    }

    function redirectToReturnShippingCart(redirectUrl) {
      addReturnShippingProductToCart().then(
        function () {
          window.location.href = redirectUrl;
        },
        function () {
          window.location.href = redirectUrl;
        }
      );
    }

    function getPaymentRedirectUrl(response, data) {
      if (response) {
        var responseUrl = response.paymentUrl || response.payment_url || response.checkoutUrl || response.checkout_url || response.nextUrl || response.next_url || '';
        if (responseUrl) return responseUrl;
      }

      return buildReturnShippingCheckoutUrl(data);
    }

    function maybeRedirectToPayment(response, data) {
      var redirectUrl = getPaymentRedirectUrl(response, data);
      if (!redirectUrl) return false;

      window.location.href = redirectUrl;
      return true;
    }

    function getFallbackBody(data) {
      var order = data.order || {};
      var customer = data.customer || {};
      var fee = data.returnShippingFee || {};
      var items = Array.isArray(data.items) && data.items.length
        ? data.items.map(function (item) {
            return '- ' + item.title + (item.sku ? ' / SKU ' + item.sku : '') + ' / Qty ' + item.quantity;
          }).join('\n')
        : '- No line items were available in the storefront payload; support should verify order items manually.';

      return [
        'Withdrawal or return request',
        '',
        'Order: ' + (order.name || order.orderNumber || ''),
        'Order email: ' + (order.email || ''),
        'Logged-in customer: ' + (customer.email || 'No'),
        'Reason: ' + (data.reasonLabel || data.reason || 'Not provided'),
        'Message: ' + (data.note || 'Not provided'),
        'Return shipping fee: ' + (fee.amount || returnShippingFeeDisplay) + ' required',
        'Payment status: pending',
        'Lookup fallback: No',
        'Requested at: ' + (data.requestedAt || ''),
        '',
        'Items:',
        items
      ].join('\n');
    }

    function submitContactFallback(data) {
      var formData = contactFallbackForm ? new FormData(contactFallbackForm) : new FormData();
      var action = contactFallbackForm ? contactFallbackForm.getAttribute('action') || '/contact' : '/contact';
      var order = data.order || {};
      var email = order.email || '';

      if (!email) {
        return Promise.reject(new Error('Missing customer email for contact fallback'));
      }

      formData.set('form_type', 'contact');
      formData.set('utf8', '1');
      formData.set('contact[email]', email);
      formData.set('contact[Order ID]', order.name || order.orderNumber || '');
      formData.set('contact[tags]', 'withdrawal-return-request');
      formData.set('contact[body]', getFallbackBody(data));

      return fetch(action, {
        method: 'POST',
        headers: {
          Accept: 'text/html'
        },
        credentials: 'same-origin',
        body: formData
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Contact fallback failed');
        }

        return {
          status: 'support_received',
          contactFallback: true
        };
      });
    }

    function submitRequest(data) {
      if (!submitEndpoint) {
        return submitContactFallback(data);
      }

      var timeout = withTimeout(requestTimeout);

      return fetch(submitEndpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        signal: timeout.signal,
        body: JSON.stringify(data)
      })
        .then(function (response) {
          timeout.clear();
          if (!response.ok) {
            throw new Error('Submit failed');
          }
          return response.json();
        })
        .catch(function () {
          timeout.clear();
          return submitContactFallback(data);
        });
    }

    if (lookupForm) {
      lookupForm.addEventListener('submit', function (event) {
        event.preventDefault();
        clearMessage();

        var orderReference = orderInput ? orderInput.value.trim() : '';
        var email = emailInput ? emailInput.value.trim() : '';

        if (!orderReference || !email) {
          showMessage('error', 'Enter both your order ID and email address to fetch your order.');
          return;
        }

        setLookupBusy(true);

        var localOrders = findLocalOrders(orderReference, email);
        if (localOrders.length) {
          renderOrders(localOrders);
          setLookupBusy(false);
          return;
        }

        fetchOrders(orderReference, email)
          .then(function (remoteOrders) {
            var orders = normalizeOrders(remoteOrders);

            if (!orders.length) {
              showMessage('error', 'No matching order was found. Check the order ID and email, then try again.');
              return;
            }

            renderOrders(orders);
          })
          .catch(function () {
            showLookupUnavailable();
          })
          .finally(function () {
            setLookupBusy(false);
          });
      });
    }

    if (useAccountButton) {
      useAccountButton.addEventListener('click', function () {
        clearMessage();
        if (!accountOrders.length) {
          showMessage('error', 'No account orders are available in this browser session.');
          return;
        }
        renderOrders(accountOrders);
      });
    }

    if (backToLookupButton) {
      backToLookupButton.addEventListener('click', function () {
        clearMessage();
        setStep(1);
      });
    }

    if (backToRequestButton) {
      backToRequestButton.addEventListener('click', function () {
        clearMessage();
        setStep(2);
      });
    }

    if (ordersNode) {
      ordersNode.addEventListener('click', function (event) {
        var button = event.target.closest('[data-cp-order-id]');
        if (!button) return;
        selectOrder(button.getAttribute('data-cp-order-id'));
      });
    }

    if (startAgainButton) {
      startAgainButton.addEventListener('click', function () {
        activeOrders = [];
        selectedOrder = null;
        if (ordersNode) ordersNode.innerHTML = '';
        if (itemsNode) itemsNode.innerHTML = '';
        setHidden(requestForm, true);
        if (requestForm) requestForm.reset();
        if (submitForm) {
          submitForm.hidden = false;
          submitForm.reset();
        }
        if (successPanel) successPanel.hidden = true;
        if (reviewSummary) reviewSummary.innerHTML = '';
        if (reasonInput) reasonInput.value = '';
        if (noteInput) noteInput.value = '';
        if (successReference) {
          successReference.textContent = '';
          successReference.hidden = true;
        }
        clearMessage();
        setStep(1);
      });
    }

    if (requestForm) {
      requestForm.addEventListener('submit', function (event) {
        event.preventDefault();
        clearMessage();
        setNextStepBusy(true);

        if (!validateSelectedRequest()) {
          setNextStepBusy(false);
          return;
        }

        renderReviewSummary();
        if (submitForm) submitForm.hidden = false;
        if (successPanel) successPanel.hidden = true;
        setStep(3);
        setNextStepBusy(false);

        if (paymentOptionInput) {
          paymentOptionInput.focus();
        }
      });
    }

    if (submitForm) {
      submitForm.addEventListener('submit', function (event) {
        event.preventDefault();
        clearMessage();

        if (!validateSelectedRequest()) return;

        if (!validatePaymentOption()) return;

        if (confirmInput && !confirmInput.checked) {
          showMessage('error', 'Confirm that you want to submit this withdrawal or return request and pay the return shipping charge.');
          confirmInput.focus();
          return;
        }

        var requestPayload = buildRequestPayload();
        var checkoutUrl = buildReturnShippingCheckoutUrl(requestPayload);

        setSubmitBusy(true);

        if (checkoutUrl) {
          submitRequest(requestPayload).catch(function () {});
          redirectToReturnShippingCart(checkoutUrl);
          return;
        }

        submitRequest(requestPayload)
          .then(function (response) {
            response = response || {};
            if (maybeRedirectToPayment(response, requestPayload)) return;

            showMessage(
              'error',
              'Return shipping checkout is not configured. Add the return shipping fee variant ID or return a checkoutUrl from the order workflow.'
            );
          })
          .catch(function () {
            showMessage(
              'error',
              'Return shipping checkout is not configured. Add the return shipping fee variant ID or return a checkoutUrl from the order workflow.'
            );
          })
          .finally(function () {
            setSubmitBusy(false);
          });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-cp-withdrawal-form]').forEach(initWithdrawalForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-cp-withdrawal-form]').forEach(initWithdrawalForm);
  });
})();
